export const createSuccessToast = {
  title: '已成功新增 $t(tracker:displayKind, {"context": "{{context}}" })',
};
